import React from 'react';
import { ModalPattern } from '..';

const AIAssistantClearChatHistoryModal = ({ onConfirm, onCancel }) => {
  return (
    <ModalPattern
      title="Clear Chat"
      className="ai-assistant-clear-history-modal"
      onCancel={onCancel}
      onConfirm={onConfirm}
      modalBody={<div>Do you want to clear chat?</div>}
      confirmText="Clear"
    />
  );
};

export default AIAssistantClearChatHistoryModal;